import { uuid } from '../utils';
import {
  ILLUSTRATION
} from './categories';

export default {
  id: uuid(),
  priority: 2,
  name: 'Awkward',
  thumbnail: './Awkward/Awk_Thumb.jpg',
  categories: [ ILLUSTRATION ],
  content: [
    './Awkward/Angels.jpg',
    './Awkward/Berries-dark.jpg',
    './Awkward/Birds.jpg',
    './Awkward/Clouder.jpg',
    './Awkward/Eggs.jpg',
    './Awkward/Faces.jpg',
    './Awkward/Fairytale.jpg',
    './Awkward/Fruhstuck.jpg',
    './Awkward/Hipsters.jpg',
    './Awkward/Oldies.jpg',
    './Awkward/OpiumScene.jpg',
    './Awkward/Scene04.jpg',
    './Awkward/Scene12.jpg',
    './Awkward/Scene14.jpg',
    './Awkward/TheTeaParty.jpg'
  ]
};




// WEBPACK FOOTER //
// ./src/projects/awkward.js